import { UPDATE_MICROSCOPY_MEASUREMENTS } from '../../../custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const updateMicroscopyMeasurements = createAsyncThunk('updateMicroscopyMeasurements', async (obj: any) => {

  try {

    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = UPDATE_MICROSCOPY_MEASUREMENTS
    let response = await fetch(url, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },

      body: JSON.stringify(obj)

    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default updateMicroscopyMeasurements;
